import React, { memo } from "react";

// Classnames
import clsx from "clsx";

// Components
import NoData from "components/NoData";
import Loader from "components/UiKit/Loader";
import CartLibrariesCompounds from "components/Carts/CartLibrariesCompounds";

// Type
import { TContent } from "pages/LibrariesCompounds/reducer";

type TList = {
  page?: number,
  size?: string,
  loading: boolean,
  data: TContent[],
}

export const List: React.FC<TList> = (props) => {
  const { data, size = "", page = 0, loading } = props;

  const cnWrapper = clsx(
    "libraries-compounds__list flex flex-jc-between flex-direction-column mb30",
    loading ? "libraries-compounds__list--active" : ""
  );

  const getNoData = () => {
    return <div
      style={{ height: "5rem" }}
      className="flex flex-ai-center flex-jc-center mt30 mb30"
    >
      <NoData text="No data available" />
    </div>;
  };

  const getList = (data: TContent[]) => {
    return data?.map(
      (item: TContent, index: number) => {
        const numeration = `${(page || 0) * +size + index + 1}`;
        return (
          <CartLibrariesCompounds
            {...item}
            key={index}
            numeration={numeration}
          />
        );
      });
  };

  const getLoader = () => {
    return <div className="libraries-compounds__loader relative mt30 mb30 full-width">
      <Loader type="circle" color="dark" />
    </div>;
  };

  return (
    <div className={cnWrapper}>
      {loading ?
        getLoader()
        :
        data?.length
          ? getList(data)
          : getNoData()}
    </div>
  );
};

export default memo(List);
